export default __webpack_public_path__ + "static/bakstol-example3-239d4beb812d2fa4667438014229eafb.png";